export class ProxyServers {
	constructor() {
		this.proxy = false;
		this.count = 0;
	}
	random() {
		this.count++;
		if (!this.proxy || 1==this.count%5) {
			this.proxy = false;
			return fetch(`/rest/proxy/random`)
				.then( res=>res.json() )
				.then( proxy => {
					// console.error(`/rest/proxy/random returned `, proxy);
					if (``==proxy.trim()) {
						return Promise.reject(`No valid proxy obtained`);
					}
					this.proxy = proxy;
					console.log(`ProxyServers:random proxy=${proxy}`)
					return Promise.resolve(proxy);					
				});
		} else {
			return Promise.resolve(this.proxy);
		}
	}
	// chooseServer chooses the proxy server the user should be sent to.
	// By default, a random server will be used, but if the site has registered
	// a 'veedo_choose_proxy_server' function, that will be used instead...
	// The veedo_choose_proxy_server function should return a Promise that
	// resolves to the string fqdn of the proxy server, or a rejection
	// if no proxy was obtained
	chooseServer() {
		if (`function`==typeof window.veedo_choose_proxy_server) {
			return window.veedo_choose_proxy_server();
		} else {
			return this.random();
		}
	}
}